import { useQuery } from "@tanstack/react-query"
import { getNodes } from "../services/query_service"

export const useNodeQuery = () => {
    return useQuery({
        queryKey: ['node'],
        queryFn: async () => getNodes()
    })
}